import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import _ from 'es-toolkit/compat';

import { Modal, ModalTopAction } from 'src/components/common';
import { VerifierStaffViewDetailsByVerifierAdminModalForm } from 'src/components/verifierStaff';
import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';

import { VerifierStaffViewDetailsByVerifierAdminModalArgs } from './types';

export const VerifierStaffViewDetailsByVerifierAdminModal: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { closeModal, switchClosability, isOpen, args } =
    useModal<VerifierStaffViewDetailsByVerifierAdminModalArgs>(
      ModalId.VerifierStaffViewDetailsByVerifierAdmin,
    );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const mobileTopAction = React.useMemo((): ModalTopAction => {
    return {
      show: true,
      render: () => (
        <IconButton onClick={() => onCloseModal()}>
          <CloseIcon />
        </IconButton>
      ),
    };
  }, [onCloseModal]);

  if (isOpen && (_.isNil(args?.verifierStaff) || _.isNil(args.isAdmin))) {
    throw new Error('Some required arguments for modal are not provided');
  }

  return (
    <Modal
      title="Staff Details"
      topAction={isMobile ? mobileTopAction : undefined}
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
        fullScreen: isMobile,
      }}
      maxWidth={600}
    >
      <VerifierStaffViewDetailsByVerifierAdminModalForm
        verifierStaff={args?.verifierStaff}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
